// extracted by mini-css-extract-plugin
export default {"ChronicalSection":"ChronicalSection_ChronicalSection__PdS3O","ChronicalSection__title":"ChronicalSection_ChronicalSection__title__515A0"};